import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import './LoadingSpinner.scss';

const LOTTIE_ANIMATION_URL = 'https://cdn.lottielab.com/l/2Q1Jz8swvBFnvy.json';

export const LoadingSpinner = (): React.ReactElement => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    fetch(LOTTIE_ANIMATION_URL)
      .then((res) => res.json())
      .then(setAnimationData);
  }, []);

  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner-inner-content">
        <div className="loading-spinner-animation-container">
          <div className="loading-spinner-animation-icon-area">
            {animationData && (
              <Lottie
                animationData={animationData}
                loop={true}
                size={72}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
